import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_DOCTORS_PACKAGES_REQUEST } from "./constants";
import { Action, DoctorPackageState } from "./types";

function items(state: DoctorPackageState = {}, action: Action): DoctorPackageState {
  switch (action.type) {
    case getSuccessActionType(FETCH_DOCTORS_PACKAGES_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_DOCTORS_PACKAGES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_DOCTORS_PACKAGES_REQUEST):
    case getFailureActionType(FETCH_DOCTORS_PACKAGES_REQUEST):
      return false;

    default:
      return state;
  }
}

export const doctorsPackages = combineReducers({ items, isFetching });
